import { useState } from "react";
import { WrappedFieldProps } from "redux-form";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

import FormGroup from "../styled/FormGroup";
import { IntlPhoneInputWrapper } from "../styled/IntlPhoneInput";
import { UNITED_STATES } from "src/constants/countries";
import { translate } from "src/services";
import { FormError, FormLabel } from "src/styled";

interface Props extends WrappedFieldProps {
  changeFieldValue: (value: string) => void;
  initialValue: string;
  margin?: string;
  width?: string;
  disabled?: boolean;
  isHidden?: boolean;
  placeholder?: string;
  label?: string;
}

const IntlPhoneNumberInput = ({
  initialValue,
  input,
  width,
  margin,
  disabled,
  isHidden,
  placeholder,
  label,
  meta: { asyncValidating, submitFailed, error },
  changeFieldValue,
}: Props) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (value: string) => {
    setValue(value);
    changeFieldValue(value);
  };

  return (
    <FormGroup
      hasValue={!!value}
      isLoading={asyncValidating}
      margin={margin}
      width={width}
      disabled={disabled}
      isHidden={isHidden}
      raisedLabel={!!label}
    >
      <IntlPhoneInputWrapper>
        {!!label && <FormLabel margin="small no no">{label}</FormLabel>}
        <PhoneInput
          international
          country={UNITED_STATES}
          placeholder={
            label
              ? ""
              : placeholder
              ? placeholder
              : translate("common.phoneNumber")
          }
          defaultCountry={UNITED_STATES}
          {...input}
          onChange={handleChange}
        />
      </IntlPhoneInputWrapper>
      {submitFailed && error && <FormError>{error}</FormError>}
    </FormGroup>
  );
};

export default IntlPhoneNumberInput;
